/* eslint-disable no-useless-catch */
/* eslint-disable indent */
import AxiosService from '@/services/axios';
import LoaderService from '@/services/loader';
import { Inject, Service } from 'vue-di-container';

import { Result } from '../models/Result';
import {
    SettleContract, ContractModel, ContractDetails, CreateContractModel,
} from '../models/contract.model';
import { ApproveRejectRequestModel } from '../models/approveRejectRequestModel';
import { ContractVerificationModel } from '@/models/contract-verification.mode';
import { ContractQueryObject } from '@/models/query-objects.model';
import { NafathRequestDTO, NafathResponseModel, NafathRequestErrorModel, NafathCheckStatusRequestDTO, NafathCheckStatusResponseModel } from '@/models/NafathModel';
import { ContractAsPDFModel } from '@/models/ContractAsPDFModel';

@Service()
export default class ContractService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async getContractDetails(code: number): Promise<Result<ContractDetails>> {
        this.loaderService.ShowLoader();
        try {
            const url = `api/Contract/GetItemDetails?code=${code}`;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (e) {
            throw e;
        } finally {
            this.loaderService.HideLoader();
        }
    }

    public async getContractAsPDF(code: number, socialId?: string): Promise<Result<string>> {
        this.loaderService.ShowLoader();
        try {
            var data = { contractCode: code, socialId: socialId } as ContractAsPDFModel;
            const url = `api/Contract/GetNajizContractPdfFile`;
            const result = await this.axiosService.axiosInstance.post(url, data);
            this.loaderService.HideLoader();
            return result.data;
        } catch (e) {
            throw e;
        } finally {
            this.loaderService.HideLoader();
        }
    }

    public async approveRejectContract(model: ApproveRejectRequestModel): Promise<Result<ContractModel>> {
        this.loaderService.ShowLoader();
        try {
            const url = 'api/Contract/ApproveRejectContract';
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (e) {
            throw e;
        } finally {
            this.loaderService.HideLoader();
        }
    }

    public async verify(request: ContractVerificationModel): Promise<Result<ContractModel>> {
        this.loaderService.ShowLoader();
        try {
            const url = 'api/Contract/verify';
            const result = await this.axiosService.axiosInstance.post(url, request);
            this.loaderService.HideLoader();
            return result.data;
        } catch (e) {
            throw e;
        } finally {
            this.loaderService.HideLoader();
        }
    }

    public async getContracts(filter: string, queryObject: ContractQueryObject): Promise<Result<ContractModel[]>> {
        this.loaderService.ShowLoader();
        try {
            const url = `api/Contract/GetContracts?query=${filter}`;
            const result = await this.axiosService.axiosInstance.post(url, queryObject);
            return result ? result.data : null;
        } catch (e) {
            throw e;
        } finally {
            this.loaderService.HideLoader();
        }
    }

    public async settleContract(model: SettleContract): Promise<Result<{ requestCode: number }>> {
        this.loaderService.ShowLoader();
        try {
            const url = 'api/Contract/SettleContract';
            const result = await this.axiosService.axiosInstance.post(url, model);
            return result.data;
        } catch (e) {
            throw e;
        } finally {
            this.loaderService.HideLoader();
        }
    }

    public async submitContract(createContractModel: CreateContractModel): Promise<Result<ContractModel>> {
        this.loaderService.ShowLoader();
        try {
            const url = 'api/Contract/SubmitContract';
            const result = await this.axiosService.axiosInstance.post(url, createContractModel);
            return result.data;
        } catch (e) {
            throw e;
        } finally {
            this.loaderService.HideLoader();
        }
    }

    public async NafathRequestByAPI(request: NafathRequestDTO): Promise<NafathResponseModel> {
        this.loaderService.ShowLoader();
        try {
            const url = 'api/Contract/NafathRequestByAPI';
            const result = await this.axiosService.axiosInstance.post(url, request);
            this.loaderService.HideLoader();
            return result.data;
        } catch (e) {
            throw e;
        } finally {
            this.loaderService.HideLoader();
        }
    }

    public async NafathCheckStatusByAPI(request: NafathCheckStatusRequestDTO): Promise<NafathCheckStatusResponseModel> {
        //this.loaderService.ShowLoader();
        try {
            const url = 'api/Contract/NafathCheckStatusByAPI';
            const result = await this.axiosService.axiosInstance.post(url, request);
            //this.loaderService.HideLoader();
            return result.data;
        } catch (e) {
            throw e;
        } finally {
            //this.loaderService.HideLoader();
        }
    }
}
